import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledGridParagraph = styled.section(_templateObject(), function (props) {
  return props.gridPhone && "grid-template-areas: ".concat(props.flip || props.flipPhone ? "\"".concat(props.gridPhone.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridPhone, ";");
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject2(), props.gridTabletPortrait && "grid-template-areas: ".concat(props.flip || props.flipTabletPortrait ? "\"".concat(props.gridTabletPortrait.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridTabletPortrait, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridTabletPortrait.split(' ').length, ", 1fr);")));
}, function (props) {
  return props.theme.media.tablet_landscape_up(_templateObject3(), props.gridTabletLandscape && "grid-template-areas: ".concat(props.flip || props.flipTabletLandscape ? "\"".concat(props.gridTabletLandscape.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridTabletLandscape, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridTabletLandscape.split(' ').length, ", 1fr);")));
}, function (props) {
  return props.theme.media.desktop_up(_templateObject4(), props.gridDesktop && "grid-template-areas: ".concat(props.flip || props.flipDesktop ? "\"".concat(props.gridDesktop.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridDesktop, ";\n      ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridDesktop.split(' ').length, ", 1fr);"), "\n    "));
}, function (props) {
  return props.theme.media.big_desktop_up(_templateObject5(), props.gridBigDesktop && "grid-template-areas: ".concat(props.flip || props.flipBigDesktop ? "\"".concat(props.gridBigDesktop.replace(/"/g, "").split(' ').reverse().join(' '), "\"") : props.gridBigDesktop, ";\n    ").concat(props.useFractions === true && "grid-template-columns: repeat(".concat(props.gridBigDesktop.split(' ').length, ", 1fr);")));
});

function GridParagraph(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  function anyGridIsInvalid(componentProps) {
    var gridPhone = componentProps.gridPhone,
        gridTabletPortrait = componentProps.gridTabletPortrait,
        gridTabletLandscape = componentProps.gridTabletLandscape,
        gridDesktop = componentProps.gridDesktop,
        gridBigDesktop = componentProps.gridBigDesktop;
    var grids = [gridPhone, gridTabletPortrait, gridTabletLandscape, gridDesktop, gridBigDesktop].filter(Boolean) // Filter nulls
    .map(function (grid) {
      return (!grid.startsWith("\"") || !grid.endsWith("\"")) && grid;
    }).filter(Boolean);

    if (grids.length > 0) {
      console.error('Error: Some GridParagraph grid templates are invalid.', grids);
      return true;
    }

    return false;
  }

  if (anyGridIsInvalid(props)) return null;
  return /*#__PURE__*/React.createElement(StyledGridParagraph, props, children);
}

GridParagraph.defaultProps = {
  gridPhone: null,
  gridTabletPortrait: null,
  gridTabletLandscape: null,
  gridDesktop: null,
  gridBigDesktop: null,
  useFractions: false,
  flip: false,
  flipPhone: false,
  flipTabletPortrait: false,
  flipTabletLandscape: false,
  flipDesktop: false,
  flipBigDesktop: false
};
GridParagraph.propTypes = {
  gridPhone: PropTypes.string,
  gridTabletPortrait: PropTypes.string,
  gridTabletLandscape: PropTypes.string,
  gridDesktop: PropTypes.string,
  gridBigDesktop: PropTypes.string,
  useFractions: PropTypes.bool,
  flip: PropTypes.bool,
  flipPhone: PropTypes.bool,
  flipTabletPortrait: PropTypes.bool,
  flipTabletLandscape: PropTypes.bool,
  flipDesktop: PropTypes.bool,
  flipBigDesktop: PropTypes.bool,
  children: PropTypes.node.isRequired
};
export default GridParagraph;